<script lang="ts">
  import { type Snippet } from 'svelte';

  import { Button, Card, InfoAlert, Loader, ReviewTemplate } from '$shared/components';
  import Label from '$provider/constants/Label';
  import type { ProfileMergeOverviewOption } from '$shared/components/types';
  import { ButtonStyle } from '$shared/constants/ButtonStyle';

  interface Props {
    processing?: boolean;
    loading?: boolean;
    disabled?: boolean;
    option: ProfileMergeOverviewOption;
    feedbackAction?: Snippet | undefined;
    children?: Snippet | undefined;
    onclickalert?: () => void;
    oncancelmerge?: () => void;
    oncloseerror?: () => void;
    oncancel?: () => void;
    onok?: () => void;
  }

  let {
    processing = false,
    loading = false,
    disabled = false,
    option,
    feedbackAction = undefined,
    children = undefined,
    onclickalert,
    oncancelmerge,
    oncloseerror,
    oncancel,
    onok
  }: Props = $props();

  let reviewTemplateDom: ReviewTemplate = $state();

  export const scrollToError = () => {
    reviewTemplateDom?.scrollToError();
  };

  const onClickInfoAlert = (): void => {
    onclickalert?.();
  };

  const onClickCancel = (): void => {
    oncancelmerge?.();
  };
</script>

{#snippet leftActionsContent()}
  <div class="left-actions">
    {#if !option?.nonMergableInfo?.nonMergable && !option?.hasNoResult}
      <Button style={ButtonStyle.NoLink} name="cancel-merge-btn" onclick={onClickCancel}>
        <div class="cancel-action">{Label.CancelMerge}</div>
      </Button>
    {/if}
  </div>
{/snippet}

<div class="template-profile-merge-overview">
  <ReviewTemplate
    {processing}
    {disabled}
    {loading}
    option={option?.templateOption}
    bind:this={reviewTemplateDom}
    leftActions={leftActionsContent}
    {feedbackAction}
    {oncloseerror}
    {oncancel}
    {onok}
  >
    {#if loading}
      <div class="loader"><Card><Loader count={3} /></Card></div>
    {:else if option?.nonMergableInfo?.nonMergable}
      <InfoAlert
        infoAlertLabel={option?.nonMergableInfo?.nonMergableReason}
        onclick={onClickInfoAlert}
      />
    {:else}
      {@render children?.()}
    {/if}
  </ReviewTemplate>
</div>

<style>
  .left-actions {
    margin-left: 8px;
  }
  .left-actions .cancel-action {
    color: var(--grey-medium);
    cursor: pointer;
  }
</style>
